import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import React, { useState, useEffect} from "react";
import './styleModal.css';
import { Snackbar } from '@mui/material';
import CustomSnackbar from '../Components/CustomSnackbar';
import { DescriptionComponents } from '../LoadingData/LoadingConnectionComponents';
import ModalMapConnection from './ModalMapConnection';
import { deleteConnectionCableCoupling, deleteConnectionCableFob, deleteConnectionCablePonBox, deleteConnectionCablePillar, 
  deleteConnectionCableWell, deleteConnectionCableHouse, deleteConnectionCableLineParent, deleteConnectionStartCable, deleteConnectionEndCable, 
  deleteConnectionPillarCable,deleteConnectionPillarCoupling,deleteConnectionPillarFob, deleteConnectionPillarPonBox, deleteConnectionWellCable,
  deleteConnectionWellFob, deleteConnectionWellCoupling, deleteConnectionCouplingHouse, deleteConnectionCouplingCable, deleteConnectionCouplingPillar,
  deleteConnectionCouplingWell, deleteConnectionFobCable, deleteConnectionFobHouse, deleteConnectionFobPillar, deleteConnectionFobWell,
  deleteConnectionPonBoxCable, deleteConnectionPonBoxHouse, deleteConnectionPonBoxPillar, 
  deleteConnectionCableCassette} from '../DeleteConnection/DeleteConnections';
import DeleteCableConnection from './DeleteComponentsConnection/DeleteCableConnection'
import DeletePillarConnection from './DeleteComponentsConnection/DeletePillarConnection';
import DeleteWellConnection from './DeleteComponentsConnection/DeleteWellConnection';
import DeleteCouplingConnection from './DeleteComponentsConnection/DeleteCouplingConnection';
import DeleteFobConnection from './DeleteComponentsConnection/DeleteFobConnection';
import DeletePonBoxConnection from './DeleteComponentsConnection/DeletePonBoxConnection';
import DeleteHouseConnection from './DeleteComponentsConnection/DeleteHouseConnection';

const ModalDeleteComponentSpecifically = ({ open, onClose, id, type, flag, groupedCoordinatesWithColorTypeAndWidth, wellData, fobLocationData, couplingLocationData,
  ponBoxLocationData, pillarData}) => {

  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
  const [dataStartCable, setDataStartCable] = useState([]);
  const [dataEndCable, setDataEndCable] = useState([]);
  const [dataConnectionCable, setDataConnectionCable] = useState([]);
  const [flagVisibleCable, setFlagVisibleCable] = useState(false);
  const [dataConnectionPillar, setDataConnectionPillar] = useState([]);
  const [flagVisiblePillar, setFlagVisiblePillar] = useState(false);
  const [dataConnectionWell, setDataConnectionWell] = useState([]);
  const [flagVisibleWell, setFlagVisibleWell] = useState(false);
  const [dataConnectionCoupling, setDataConnectionCoupling] = useState([]);
  const [flagVisibleCoupling, setFlagVisibleCoupling] = useState(false);
  const [dataConnectionFob, setDataConnectionFob] = useState([]);
  const [flagVisibleFob, setFlagVisibleFob] = useState(false);
  const [dataConnectionHouse, setDataConnectionHouse] = useState([]);
  const [flagVisibleHouse, setFlagVisibleHouse] = useState(false);
  const [dataConnectionPonBox, setDataConnectionPonBox] = useState([]);
  const [flagVisiblePonBox, setFlagVisiblePonBox] = useState(false);
  const [openVewingModal,  setOpenVewingModal] = useState(false); 

  const [filteredWellData,  setFilteredWellData] = useState([]); 
  const [filteredFobData,  setFilteredFobData] = useState([]); 
  const [filteredCouplingData,  setFilteredCouplingData] = useState([]); 
  const [filteredPonBoxData,  setFilteredPonBoxData] = useState([]); 
  const [filteredPillarData,  setFilteredPillarData] = useState([]); 

  // Well
  useEffect(() => {
    if (Array.isArray(dataConnectionCable.listConnectionCable)) {
      const wellIds = dataConnectionCable.listConnectionCable
        .map(cable => cable.wellId) 
        .filter(id => id !== null); 

      const filteredData = wellData.filter(well => wellIds.includes(well.id));
      setFilteredWellData(filteredData);    
    } else {
      
    }
  }, [dataConnectionCable, wellData]); 

   // Pillar
   useEffect(() => {
    if (Array.isArray(dataConnectionCable.listConnectionCable)) {
      const pillarIds = dataConnectionCable.listConnectionCable
        .map(cable => cable.pillarId)
        .filter(id => id !== null);
  
      const filteredData = pillarData.filter(pillar => pillarIds.includes(pillar.id));
      setFilteredPillarData(filteredData);       
    }
  }, [dataConnectionCable, pillarData]);


  // Fob
  useEffect(() => {
    if (Array.isArray(dataConnectionCable.listConnectionCable)) {
      const fobIds = dataConnectionCable.listConnectionCable
        .map(cable => cable.fobLocationId) 
        .filter(id => id !== null);

      const filteredData = fobLocationData.filter(fob => fobIds.includes(fob.id));
      setFilteredFobData(filteredData);    
    } else {     
    }
  }, [dataConnectionCable, fobLocationData]); 

  // Coupling
  useEffect(() => {
    if (Array.isArray(dataConnectionCable.listConnectionCable)) {
      const couplingIds = dataConnectionCable.listConnectionCable
        .map(cable => cable.couplingLocationId) 
        .filter(id => id !== null);

      const filteredData = couplingLocationData.filter(coupling => couplingIds.includes(coupling.id));
      setFilteredCouplingData(filteredData);    
    } else {     
    }
  }, [dataConnectionCable, couplingLocationData]); 

  // PonBox
  useEffect(() => {
    if (Array.isArray(dataConnectionCable.listConnectionCable)) {
      const ponBoxIds = dataConnectionCable.listConnectionCable
        .map(cable => cable.ponBoxLocationId) 
        .filter(id => id !== null);

      const filteredData = ponBoxLocationData.filter(ponBox => ponBoxIds.includes(ponBox.id));
      setFilteredPonBoxData(filteredData);    
    } else {     
    }
  }, [dataConnectionCable, ponBoxLocationData]); 

 

  useEffect(() => {
    if (open) {
  descriptionComponents();
    }
  }, [open]);

  const descriptionComponents = async () => {
     DescriptionComponents(type, id, showSnackbar, setFlagVisiblePillar, setFlagVisibleWell, setFlagVisibleCoupling,
         setFlagVisibleFob, setDataStartCable, setDataEndCable, setDataConnectionCable, setFlagVisibleCable,setDataConnectionPillar,
         setDataConnectionWell, setDataConnectionCoupling, setDataConnectionFob, setDataConnectionHouse, setFlagVisibleHouse,
         setFlagVisiblePonBox, setDataConnectionPonBox);       
  } 


  const handleClose = () => {
    onClose(); 
    setDataEndCable([]);
    setDataStartCable([]);
    setDataConnectionCable([]);
    setDataConnectionPillar([]);
    setDataConnectionCoupling([]);
    setDataConnectionFob([]);
    setDataConnectionPonBox([]);
    setFlagVisibleCable(false)
    setFlagVisiblePillar(false);
    setFlagVisibleWell(false);
    setFlagVisibleCoupling(false);
    setFlagVisibleFob(false);
    setFlagVisibleHouse(false);
    setFlagVisiblePonBox(false);

    setFilteredWellData([]);
    setFilteredFobData([]);
    setFilteredPillarData([]);
    setFilteredCouplingData([]);
    setFilteredPonBoxData([]);
  };



  const openModalMapConnection = () => {
    setOpenVewingModal(true);
  }; 


  // DELETE CABLE
  const deleteCableCoupling = (cableId, couplingId) => {
    deleteConnectionCableCoupling(cableId, couplingId, descriptionComponents);
  }; 

  const deleteCableFob = (cableId, fobId) => {
    deleteConnectionCableFob(cableId, fobId, descriptionComponents);
   
  }; 

  const deleteCablePonBox = (cableId, ponBoxId) => {
    deleteConnectionCablePonBox(cableId, ponBoxId, descriptionComponents);
  };

  const deleteCablePillar = (cableId, pillarId) => {
    deleteConnectionCablePillar(cableId, pillarId, descriptionComponents);
  };

  const deleteCableWell = (cableId, wellId) => {
    deleteConnectionCableWell(cableId, wellId, descriptionComponents);
  };

   const deleteCableCassette = (cableId, CassetteId) => {
    deleteConnectionCableCassette(cableId, CassetteId, descriptionComponents);
  };

  const deleteCableHouse = (cableId, houseId, entrance) => {
    deleteConnectionCableHouse(cableId, houseId, entrance, descriptionComponents);
  };

  const deleteCableLineParent = (cableId, lineParentId) => {
    deleteConnectionCableLineParent(cableId, lineParentId, descriptionComponents);
  };

  const deleteStartCable = (cableId, conponentId, type) => {
    deleteConnectionStartCable(cableId, conponentId, type, descriptionComponents);
  };

  const deleteEndCable = (cableId, conponentId, type) => {
    deleteConnectionEndCable(cableId, conponentId, type, descriptionComponents);
  };

  // DELETE PILLAR
  const deletePillarCoupling = (pillarId, couplingId) => {
    deleteConnectionPillarCoupling(pillarId, couplingId, descriptionComponents);
  }; 

  const deletePillarFob = (pillarId, fobId) => {
    deleteConnectionPillarFob(pillarId, fobId, descriptionComponents);
   
  }; 

  const deletePillarPonBox = (pillarId, ponBoxId) => {
    deleteConnectionPillarPonBox(pillarId, ponBoxId, descriptionComponents);
  };

  const deletePillarCable = (pillarId, cableId) => {
    deleteConnectionPillarCable(pillarId, cableId, descriptionComponents);
  };

   // DELETE WELL
   const deleteWellCoupling = (wellId, couplingId) => {
    deleteConnectionWellCoupling(wellId, couplingId, descriptionComponents);
  }; 

  const deleteWellFob = (wellId, fobId) => {
    deleteConnectionWellFob(wellId, fobId, descriptionComponents);
   
  }; 

  const deleteWellCable = (wellId, cableId) => {
    deleteConnectionWellCable(wellId, cableId, descriptionComponents);
  };

   // DELETE COUPLING
   const deleteCouplingHouse = (couplingId, houseId) => {
    deleteConnectionCouplingHouse(couplingId, houseId, descriptionComponents);
  }; 

  const deleteCouplingPillar = (couplingId, pillarId) => {
    deleteConnectionCouplingPillar(couplingId, pillarId, descriptionComponents);
   
  }; 

  const deleteCouplingWell= (couplingId, wellId) => {
    deleteConnectionCouplingWell(couplingId, wellId, descriptionComponents);
  };

  const deleteCouplingCable = (couplingId, cableId) => {
    deleteConnectionCouplingCable(couplingId, cableId, descriptionComponents);
  };

  // DELETE FOB
  const deleteFobHouse = (fobId, houseId) => {
    deleteConnectionFobHouse(fobId, houseId, descriptionComponents);
  }; 

  const deleteFobPillar = (fobId, pillarId) => {
    deleteConnectionFobPillar(fobId, pillarId, descriptionComponents);
   
  }; 

  const deleteFobWell= (fobId, wellId) => {
    deleteConnectionFobWell(fobId, wellId, descriptionComponents);
  };

  const deleteFobCable = (fobId, cableId) => {
    deleteConnectionFobCable(fobId, cableId, descriptionComponents);
  };

   // DELETE PON-BOX
   const deletePonBoxHouse = (ponBoxId, houseId) => {
    deleteConnectionPonBoxHouse(ponBoxId, houseId, descriptionComponents);
  }; 

  const deletePonBoxPillar = (ponBoxId, pillarId) => {
    deleteConnectionPonBoxPillar(ponBoxId, pillarId, descriptionComponents);
   
  }; 

  const deletePonBoxCable = (ponBoxId, cableId) => {
    deleteConnectionPonBoxCable(ponBoxId, cableId, descriptionComponents);
  };

    return (
    <Dialog open={open} className="modalStyle">
      <DialogContent>
      <div style={{ position: 'relative' }}> 
      <label style={{ color: '#dfab01', fontSize: '20px', fontFamily: 'unset' }}>
        {flag} ID: {id}
      </label>
      {type === "Cable" && (
        <button
          className='buttonIsModal'
          onClick={openModalMapConnection}
          style={{
            position: 'absolute', 
            top: '0',  
            right: '0' 
          }}
        >
          Связи на карте
        </button>
      )}
    </div>
      <hr className='horizontalLineModal'/>
      <div>

      <div>
      <DeleteCableConnection
        flagVisibleCable={flagVisibleCable}
        dataStartCable={dataStartCable}
        dataEndCable={dataEndCable}
        dataConnectionCable={dataConnectionCable}
        deleteStartCable={deleteStartCable}
        deleteEndCable={deleteEndCable}
        deleteCableCoupling={deleteCableCoupling}
        deleteCablePonBox={deleteCablePonBox}
        deleteCableFob={deleteCableFob}
        deleteCablePillar={deleteCablePillar}
        deleteCableWell={deleteCableWell}
        deleteCableHouse={deleteCableHouse}
        deleteCableLineParent={deleteCableLineParent}
        deleteCableCassette={deleteCableCassette}
        id={id}
      />
    </div>

    <div>
    <DeletePillarConnection
      flagVisiblePillar={flagVisiblePillar}
      dataConnectionPillar={dataConnectionPillar}
      deletePillarCoupling={deletePillarCoupling}
      deletePillarPonBox={deletePillarPonBox}
      deletePillarFob={deletePillarFob}
      deletePillarCable={deletePillarCable}
      id={id} 
    />
    </div>

    <div>
      <DeleteWellConnection
        flagVisibleWell={flagVisibleWell}
        dataConnectionWell={dataConnectionWell}
        id={id}
        deleteWellCoupling={deleteWellCoupling}
        deleteWellFob={deleteWellFob}
        deleteWellCable={deleteWellCable}
      />
    </div>

    <div>
      <DeleteCouplingConnection
        flagVisibleCoupling={flagVisibleCoupling}
        dataConnectionCoupling={dataConnectionCoupling}
        deleteCouplingHouse={deleteCouplingHouse}
        deleteCouplingPillar={deleteCouplingPillar}
        deleteCouplingWell={deleteCouplingWell}
        deleteCouplingCable={deleteCouplingCable}
        id={id}
      />
    </div>

    <div>
      <DeleteFobConnection
        flagVisibleFob={flagVisibleFob}
        dataConnectionFob={dataConnectionFob}
        deleteFobHouse={deleteFobHouse}
        deleteFobPillar={deleteFobPillar}
        deleteFobWell={deleteFobWell}
        deleteFobCable={deleteFobCable}
        id={id}
      />
    </div>

    <div>
    <DeletePonBoxConnection
      flagVisiblePonBox={flagVisiblePonBox} 
      dataConnectionPonBox={dataConnectionPonBox} 
      id={id} 
      deletePonBoxHouse={deletePonBoxHouse} 
      deletePonBoxPillar={deletePonBoxPillar} 
      deletePonBoxCable={deletePonBoxCable} 
    />
    </div>

    <div>
     <DeleteHouseConnection
        flagVisibleHouse={flagVisibleHouse} 
       dataConnectionHouse={dataConnectionHouse} 
     />
    </div>
      
    </div>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} class='buttonIsHideModal'>
          Закрыть
        </Button>
      </DialogActions>

      {type === "Cable" && (
        <ModalMapConnection
          open={openVewingModal}
          onClose={() => setOpenVewingModal(false)}
          groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth[id]}
          filteredWellData={filteredWellData}
          filteredFobData={filteredFobData}
          filteredCouplingData={filteredCouplingData}
          filteredPonBoxData={filteredPonBoxData}
          filteredPillarData={filteredPillarData}
        />
      )}

      {/* Snackbar */}
      <Snackbar
          anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
          }}
          open={snackbarOpen}
          autoHideDuration={3000}
          onClose={handleCloseSnackbar}
          message={snackbarMessage}
          ContentProps={{
            style: {
              color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
            }
          }}
        />
    </Dialog>
  );
}

export default ModalDeleteComponentSpecifically;
